<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Device Dashboard</span>
    </div>
  </div>

  <!-- KPI Section -->
  <div class="kpi-section">
    <!-- Total Production Devices -->
    <div
      class="kpi-card kpi-gradient-blue"
      (click)="fetchDeviceList('Total Production Devices')"
      tabindex="0"
      (keydown.enter)="fetchDeviceList('Total Production Devices')"
    >
      <div class="kpi-details">
        <span class="kpi-content"
          >Total Production Devices
          <app-info-tooltip
            block
            heading="Total Production Devices"
            [description]="kpiInfo.totalProduction"
            (click)="$event.stopPropagation()"
          ></app-info-tooltip
        ></span>
        <span class="kpi-value">
          {{
            (productionDeviceCount ? productionDeviceCount : 0) | indianNumber
          }}
        </span>
      </div>
      <div class="kpi-visual">
        <img
          loading="lazy"
          src="../../assets/production.png"
          alt="Production Device Image"
        />
      </div>
    </div>

    <!-- Dispatched Devices -->
    <div
      class="kpi-card kpi-gradient-purple"
      (click)="fetchDeviceList('Dispatched Devices')"
      tabindex="0"
      (keydown.enter)="fetchDeviceList('Dispatched Devices')"
    >
      <div class="kpi-details">
        <span class="kpi-content"
          >Dispatched Devices
          <app-info-tooltip
            block
            heading="Dispatched Devices"
            [description]="kpiInfo.dispatched"
            (click)="$event.stopPropagation()"
          ></app-info-tooltip
        ></span>
        <span class="kpi-value">
          {{ (dispatchedCount ? dispatchedCount : 0) | indianNumber }}
        </span>
      </div>
      <div class="kpi-visual">
        <img
          loading="lazy"
          src="../../assets/dispatched.png"
          alt="Dispatched Devices Image"
        />
      </div>
    </div>

    <!-- Active AIS140 Certified Devices -->
    <div
      class="kpi-card kpi-gradient-pink"
      (click)="fetchDeviceList('Active AIS140 Certified Devices')"
      tabindex="0"
      (keydown.enter)="fetchDeviceList('Active AIS140 Certified Devices')"
    >
      <div class="kpi-details">
        <span class="kpi-content"
          >Active AIS140 Certified Devices
          <app-info-tooltip
            block
            heading="Active AIS140 Certified Devices"
            [description]="kpiInfo.aisCertified"
            (click)="$event.stopPropagation()"
          ></app-info-tooltip
        ></span>
        <span class="kpi-value">{{
          (aisCount ? aisCount : 0) | indianNumber
        }}</span>
      </div>
      <div class="kpi-visual">
        <img
          src="../../assets/certified.png"
          alt="Active AIS140 Certified Devices Image"
        />
      </div>
    </div>

    <!-- Installed Devices -->
    <div
      class="kpi-card kpi-gradient-orange"
      (click)="fetchDeviceList('Installed Devices')"
      tabindex="0"
      (keydown.enter)="fetchDeviceList('Installed Devices')"
    >
      <div class="kpi-details">
        <span class="kpi-content"
          >Installed Devices
          <app-info-tooltip
            block
            heading="Installed Devices"
            [description]="kpiInfo.installed"
            (click)="$event.stopPropagation()"
          ></app-info-tooltip
        ></span>
        <span class="kpi-value">
          {{ (installedCount ? installedCount : 0) | indianNumber }}
        </span>
      </div>
      <div class="kpi-visual">
        <img
          loading="lazy"
          src="../../assets/installed.png"
          alt="Installed Devices Image"
        />
      </div>
    </div>
  </div>

  <!-- Graph Section -->
  <div class="graph-section">
    <!-- Devices Not Active From Graph-->
    <div
      class="graph-card"
      tabindex="0"
      (keydown.enter)="fetchDeviceList('Device Activity Overview')"
      (click)="fetchDeviceList('Device Activity Overview')"
    >
      <div class="graph-header">
        <h3 class="graph-title">
          Device Activity Overview
          <app-info-tooltip
            heading="Device Activity Overview"
            [description]="graphInfo.deviceActivityOverview"
            (click)="$event.stopPropagation()"
          ></app-info-tooltip>
        </h3>
        <button
          type="button"
          class="graph-btn"
          (click)="deviceModelWiseDeviceActivityOverview()"
        >
          Device Model Wise
        </button>
      </div>
      <div class="graph-body">
        <canvas
          baseChart
          [data]="deviceActivityOverviewBarChartData"
          [options]="barChartOption"
          [type]="'bar'"
        >
        </canvas>
      </div>
    </div>
    <!-- Firmware Wise Details Graph-->
    <div
      class="graph-card"
      tabindex="0"
      (keydown.enter)="fetchDeviceList('Firmware Wise Details')"
      (click)="fetchDeviceList('Firmware Wise Details')"
    >
      <div class="graph-header">
        <h3 class="graph-title">
          Firmware Wise Details
          <app-info-tooltip
            heading="Firmware Wise Details"
            [description]="graphInfo.firmwareWiseDetails"
            (click)="$event.stopPropagation()"
          ></app-info-tooltip>
        </h3>
        <button
          type="button"
          class="graph-btn"
          (click)="deviceModelWiseFirmwareDetailsGraph()"
        >
          Device Model Wise
        </button>
      </div>
      <div class="graph-body">
        <canvas
          baseChart
          [data]="firmwareWiseDeviceBarChartData"
          [options]="barChartOption"
          [type]="'bar'"
        >
        </canvas>
      </div>
    </div>

    <!-- State Wise Details Graph-->
    <div
      class="graph-card"
      tabindex="0"
      (keydown.enter)="fetchDeviceList('State Wise Details')"
      (click)="fetchDeviceList('State Wise Details')"
    >
      <div class="graph-header">
        <h3 class="graph-title">
          State Wise Details
          <app-info-tooltip
            heading="State Wise Details"
            [description]="graphInfo.stateWiseDetails"
            (click)="$event.stopPropagation()"
          ></app-info-tooltip>
        </h3>
      </div>
      <div class="graph-body">
        <canvas
          baseChart
          [data]="stateWiseDeviceBarChartData"
          [options]="barChartOption"
          [type]="'bar'"
        >
        </canvas>
      </div>
    </div>
  </div>

  <!-- List Section -->
  <form [formGroup]="deviceDashboardForm" novalidate>
    <div class="component-container" #tableContainer>
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">{{ selectedComponentTitle }}</h6>
        <div class="component-actions">
          <!-- Total Production Devices -->
          @if (selectedComponentTitle === 'Total Production Devices') {
            <button
              class="primary-button"
              (click)="downloadAllDeviceReport()"
              type="button"
            >
              Download Report<mat-icon class="btn-icon">download</mat-icon>
            </button>
            <app-common-search
              [initialSearchValue]="
                deviceDashboardForm?.get('searchTotalProduct')?.value
              "
              matTooltip="UIN NO. | IMEI NO. | ICCID NO. | Model Name | VIN/Chassis No. | Firmware Version"
              [enableBulkSearch]="true"
              (searchSubmit)="onSearch($event)"
              (bulkSearchSubmit)="onBulkSearch($event)"
            ></app-common-search>
          }
          <!-- Dispatched Devices -->
          @if (selectedComponentTitle === 'Dispatched Devices') {
            <button
              class="primary-button"
              [disabled]="listData.length === 0 || isDownloading"
              (click)="exportToExcelDashboardList()"
              type="button"
            >
              Download Report<mat-icon class="btn-icon">download</mat-icon>
            </button>
            <app-common-search
              [initialSearchValue]="
                deviceDashboardForm?.get('searchDispatchedDevices')?.value
              "
              matTooltip="UIN NO. | IMEI NO. | ICCID NO. | Model Name | VIN/Chassis No. | Firmware Version"
              [enableBulkSearch]="true"
              (searchSubmit)="onSearch($event)"
              (bulkSearchSubmit)="onBulkSearch($event)"
            ></app-common-search>
          }
          <!-- Active AIS140 Certified Devices -->
          @if (selectedComponentTitle === 'Active AIS140 Certified Devices') {
            <button
              class="primary-button"
              [disabled]="listData.length === 0 || isDownloading"
              (click)="exportToExcelDashboardList()"
              type="button"
            >
              Download Report<mat-icon class="btn-icon">download</mat-icon>
            </button>
            <app-common-search
              [initialSearchValue]="
                deviceDashboardForm?.get('searchCertifiedDevices')?.value
              "
              matTooltip="UIN NO. | IMEI NO. | ICCID NO. | VIN/Chassis No."
              [enableBulkSearch]="true"
              (searchSubmit)="onSearch($event)"
              (bulkSearchSubmit)="onBulkSearch($event)"
            ></app-common-search>
          }
          <!-- Installed Devices -->
          @if (selectedComponentTitle === 'Installed Devices') {
            <button
              class="primary-button"
              [disabled]="listData.length === 0 || isDownloading"
              (click)="exportToExcelDashboardList()"
              type="button"
            >
              Download Report<mat-icon class="btn-icon">download</mat-icon>
            </button>
            <app-common-component-dropdown-search
              [items]="firmwareNamesList"
              [initialValue]="
                deviceDashboardForm?.get(
                  'firmwareWiseSortByInstalledDeviceFilterValue'
                )?.value
              "
              [placeHolder]="'Select Firmware Version'"
              (itemSelected)="onFirmwareWiseSelectionForInstalledChange($event)"
            ></app-common-component-dropdown-search>
            <app-common-search
              [initialSearchValue]="
                deviceDashboardForm?.get('searchInstalledDevices')?.value
              "
              matTooltip="UIN NO. | IMEI NO. | ICCID NO. | Model Name | VIN/Chassis No. | Firmware Version"
              [enableBulkSearch]="true"
              (searchSubmit)="onSearch($event)"
              (bulkSearchSubmit)="onBulkSearch($event)"
            ></app-common-search>
          }
          <!-- Device Activity Overview Graph-->
          @if (selectedComponentTitle === 'Device Activity Overview') {
            <button
              class="primary-button"
              [disabled]="listData.length === 0 || isDownloading"
              (click)="exportToExcelDashboardList()"
              type="button"
            >
              Download Report<mat-icon class="btn-icon">download</mat-icon>
            </button>
            <app-common-component-dropdown-search
              [items]="activityOverviewFilter"
              [initialValue]="
                deviceDashboardForm?.get('devicesActivityOverviewSortBy')?.value
              "
              [placeHolder]="'Select Activity Version'"
              (itemSelected)="onDevicesNotActiveSelectionChange($event)"
            ></app-common-component-dropdown-search>
            <app-common-search
              [initialSearchValue]="
                deviceDashboardForm?.get('searchDevicesActivityOverview')?.value
              "
              matTooltip="UIN NO. | IMEI NO. | ICCID NO. | Model Name | VIN/Chassis No. | Firmware Version"
              [enableBulkSearch]="true"
              (searchSubmit)="onSearch($event)"
              (bulkSearchSubmit)="onBulkSearch($event)"
            ></app-common-search>
          }
          <!-- Firmware Wise Details Graph-->
          @if (selectedComponentTitle === 'Firmware Wise Details') {
            <button
              class="primary-button"
              [disabled]="listData.length === 0 || isDownloading"
              (click)="exportToExcelDashboardList()"
              type="button"
            >
              Download Report<mat-icon class="btn-icon">download</mat-icon>
            </button>
            <app-multi-select-dropdown
              [items]="firmwareNamesList"
              [initialValue]="
                deviceDashboardForm?.get('firmwareWiseSortBy')?.value
              "
              [placeHolder]="'Select Firmware Version'"
              (selectionChange)="onFirmwareWiseSelectionChange($event)"
            ></app-multi-select-dropdown>
            <app-common-search
              [initialSearchValue]="
                deviceDashboardForm?.get('searchFirmwareWiseDetails')?.value
              "
              matTooltip="UIN NO. | IMEI NO. | ICCID NO. | Model Name | VIN/Chassis No. | Firmware Version"
              [enableBulkSearch]="true"
              (searchSubmit)="onSearch($event)"
              (bulkSearchSubmit)="onBulkSearch($event)"
            ></app-common-search>
          }
          <!-- State Wise Details Graph-->
          @if (selectedComponentTitle === 'State Wise Details') {
            <button
              class="primary-button"
              [disabled]="listData.length === 0 || isDownloading"
              (click)="exportToExcelDashboardList()"
              type="button"
            >
              Download Report<mat-icon class="btn-icon">download</mat-icon>
            </button>
            <app-common-component-dropdown-search
              [items]="stateNamesList"
              [initialValue]="
                deviceDashboardForm?.get('stateWiseSortBy')?.value
              "
              [placeHolder]="'Select State'"
              (itemSelected)="onStateWiseSelectionChange($event)"
            ></app-common-component-dropdown-search>
            <app-common-search
              [initialSearchValue]="
                deviceDashboardForm?.get('searchStateWiseDetails')?.value
              "
              matTooltip="UIN NO. | IMEI NO. | ICCID NO. | Model Name | VIN/Chassis No. | Firmware Version"
              [enableBulkSearch]="true"
              (searchSubmit)="onSearch($event)"
              (bulkSearchSubmit)="onBulkSearch($event)"
            ></app-common-search>
          }
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              @for (header of unifiedHeader; track header) {
                <th>
                  {{ header }}
                </th>
              }
              @if (DeviceDetailsView) {
                <th>Action</th>
              }
            </tr>
          </thead>
          @if (listData.length > 0) {
            <tbody>
              @for (element of listData; track element) {
                <tr>
                  @for (
                    configA of unifiedHeaderValue
                      | paginate
                        : {
                            id: 'paginate',
                            itemsPerPage: size,
                            currentPage: page,
                            totalItems: totalCount,
                          };
                    track configA
                  ) {
                    <td tabindex="0">
                      {{ element[configA] || '--' }}
                    </td>
                  }
                  <td>
                    <div class="action-buttons">
                      @if (DeviceDetailsView) {
                        <button
                          type="button"
                          class="primary-button view-button"
                          (click)="view(element.uid, element.imei)"
                        >
                          <mat-icon class="btn-icon">visibility</mat-icon>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (listData.length === 0) {
            <tbody>
              <tr>
                <td colspan="9">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Footer Section -->
      <div class="component-footer">
        @if (listData.length > 0) {
          <app-common-component-pagination
            [totalItems]="totalCount"
            [pageSize]="size"
            [currentPage]="page"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  </form>
</div>

<!-- Device Model Wise Device Activity Overview Graph Popup section -->
<div class="custom-container">
  <!-- Device Model Wise Inactive Device Graph Modal -->
  <div
    class="custom-modal custom-modal-xl"
    id="DeviceModelWiseDeviceActivityOverviewGraph"
  >
    <div class="custom-modal-dialog">
      <div class="custom-modal-content">
        <!-- Modal Header -->
        <div class="custom-modal-header">
          <h4 class="custom-modal-title">
            Device Model Wise Inactive Device Overview Graph
          </h4>
          <button type="button" class="custom-close-btn" (click)="closeModal()">
            &times;
          </button>
        </div>
        <!-- Modal Body -->
        <div class="custom-modal-body">
          <div class="graph-section">
            <!-- Iterate through each device model and create a chart for each -->
            @for (
              deviceModel of deviceModelWiseDeviceActivityOverviewGraph;
              track deviceModel
            ) {
              <div class="graph-card" tabindex="0">
                <div class="graph-header">
                  <h3 class="graph-title">
                    {{ deviceModel.datasets[0].label }}
                  </h3>
                  <button
                    class="graph-btn"
                    [disabled]="isDownloading"
                    (click)="
                      downloadAllDeviceActivityReport(
                        deviceModel.datasets[0].label
                      )
                    "
                    type="button"
                  >
                    Download Details
                  </button>
                </div>
                <div class="graph-body">
                  <canvas
                    baseChart
                    [data]="deviceModel"
                    [options]="barChartOption"
                    [type]="'bar'"
                  ></canvas>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Device Model Wise Firmware Details Graph Popup section -->
<div class="custom-container">
  <!-- Device Model Wise Firmware Details Graph Modal -->
  <div
    class="custom-modal custom-modal-xxl"
    id="deviceModelWiseFirmwareDetailsGraph"
  >
    <div class="custom-modal-dialog">
      <div class="custom-modal-content">
        <!-- Modal Header -->
        <div class="custom-modal-header">
          <h4 class="custom-modal-title">
            Device Model Wise Firmware Details Overview Graph
          </h4>
          <button type="button" class="custom-close-btn" (click)="closeModal()">
            &times;
          </button>
        </div>
        <!-- Modal Body -->
        <div class="custom-modal-body">
          <div class="graph-section">
            <!-- Iterate through each device model and create a chart for each -->
            @for (
              deviceModel of deviceModelWiseFirmwareNamesList;
              track deviceModel
            ) {
              <div class="graph-card" tabindex="0">
                <div class="graph-header">
                  <h3 class="graph-title">
                    {{ deviceModel.datasets[0].label }}
                  </h3>
                  <button
                    class="graph-btn"
                    [disabled]="isDownloading"
                    (click)="
                      downloadFirmwareWiseGraphDetailsReport(
                        deviceModel.datasets[0].label
                      )
                    "
                    type="button"
                  >
                    Download Details
                  </button>
                </div>
                <div class="graph-body">
                  <canvas
                    baseChart
                    [data]="deviceModel"
                    [options]="barChartOption"
                    [type]="'bar'"
                  ></canvas>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
